import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface LockboxCheckDetailsPayload {
  vendor_id?: string;
  vendor_name?: string;
  benefit_of?: string;
  city?: string;
  state?: string;
  zip?: string;
  address_line_1?: string;
  address_line_2?: string | null;
}

interface Props {
  lockboxId?: string;
}

const useUpdateLockboxCheckDetailsQuery = ({ lockboxId }: Props) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isError } = useMutation(
    (checkDetails: LockboxCheckDetailsPayload) =>
      api.put(API_URL.LOCKBOXES_CHECK_DETAILS_BY_LOCKBOX_ID(lockboxId || ''), checkDetails),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [API_URL.ACTIVITY_LOGS] });
        queryClient.invalidateQueries({ queryKey: [API_URL.LOCKBOXES_BY_LOCKBOX_ID(lockboxId || '')] });
      },
    }
  );

  return {
    updateLockboxCheckDetails: mutateAsync,
    isLoading,
    isError,
  };
};

export default useUpdateLockboxCheckDetailsQuery;
